import {
  type Business,
  type Conditions,
  type LocationDetail,
  type SurchargePayments,
  type Surcharges,
} from '@/api/accommodation/types'
import SurchargesCard from './SurchargesCard'
import yesAdultIcon from '@/assets/icons/conditions/yes-adult.svg'
import noAdultIcon from '@/assets/icons/conditions/no-adult.svg'
import yesPetsIcon from '@/assets/icons/conditions/yes-pets.svg'
import noPetsIcon from '@/assets/icons/conditions/no-pets.svg'
import yesSmokingIcon from '@/assets/icons/conditions/yes-smoking.svg'
import noSmokingIcon from '@/assets/icons/conditions/no-smoking.svg'
import yesPartiesIcon from '@/assets/icons/conditions/yes-parties.svg'
import noPartiesIcon from '@/assets/icons/conditions/no-parties.svg'
import timeTwentyFourIcon from '@/assets/icons/conditions/time-twenty-four.svg'
import holdingHandKeyIcon from '@/assets/icons/conditions/holding-hand-key.svg'
import taxAltIcon from '@/assets/icons/conditions/tax-alt.svg'
import termsDocumentIcon from '@/assets/icons/conditions/terms-document.svg'

function ConditionsCard({
  check,
  conditions,
  surcharges,
  business,
  surchargePayments,
}: {
  check: LocationDetail['check']
  conditions: Conditions
  surcharges: Surcharges
  business: Business
  surchargePayments: SurchargePayments
}) {
  return (
    <div className="space-y-2 text-sm">
      <div className="flex items-center gap-4 rounded-xl bg-slate-100/50 px-6 py-4">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.115 0.694254C10.809 0.418784 10.4118 0.266357 10 0.266357C9.58824 0.266357 9.19105 0.418784 8.885 0.694254L0 8.69092V17.3576C0 18.0648 0.280952 18.7431 0.781049 19.2432C1.28115 19.7433 1.95942 20.0243 2.66667 20.0243H17.3333C18.0406 20.0243 18.7189 19.7433 19.219 19.2432C19.719 18.7431 20 18.0648 20 17.3576V8.69092L11.115 0.694254ZM12.5 18.3551H7.5V14.1668C7.5 13.5037 7.76339 12.8678 8.23223 12.399C8.70107 11.9301 9.33696 11.6668 10 11.6668C10.663 11.6668 11.2989 11.9301 11.7678 12.399C12.2366 12.8678 12.5 13.5037 12.5 14.1668V18.3551ZM18.3333 17.3551C18.3333 17.6203 18.228 17.8747 18.0404 18.0622C17.8529 18.2497 17.5985 18.3551 17.3333 18.3551H14.1667V14.1668C14.1667 13.0617 13.7277 12.0019 12.9463 11.2205C12.1649 10.4391 11.1051 10.0001 10 10.0001C8.89493 10.0001 7.83512 10.4391 7.05372 11.2205C6.27232 12.0019 5.83333 13.0617 5.83333 14.1668V18.3551H2.66667C2.40145 18.3551 2.1471 18.2497 1.95956 18.0622C1.77202 17.8747 1.66667 17.6203 1.66667 17.3551V9.43259L10 1.93259L18.3333 9.43259V17.3551Z"
            fill="#1E1E1E"
          />
        </svg>
        <div>
          <p>
            Check in - {check.inType.name} - od {check.in}
          </p>
          <p>
            Check out - {check.outType.name} - do {check.out}
          </p>
        </div>
      </div>

      {conditions.adult && (
        <div className="flex items-center gap-4 rounded-xl bg-slate-100/50 px-6 py-4">
          <img src={yesAdultIcon} alt="smoking" className="h-6 w-6" />
          Jen pro dospělé
        </div>
      )}
      {!conditions.adult && (
        <div className="flex items-center gap-4 rounded-xl bg-slate-100/50 px-6 py-4">
          <img src={noAdultIcon} alt="smoking" className="h-6 w-6" />
          Vhodné i pro děti
        </div>
      )}

      {conditions.pets && (
        <div className="flex items-center gap-4 rounded-xl bg-slate-100/50 px-6 py-4">
          <img src={yesPetsIcon} alt="smoking" className="h-6 w-6" />
          Domácí mazlíčci povoleni
        </div>
      )}
      {!conditions.pets && (
        <div className="flex items-center gap-4 rounded-xl bg-slate-100/50 px-6 py-4">
          <img src={noPetsIcon} alt="smoking" className="h-6 w-6" />
          Domácí mazlíčci zakázáni
        </div>
      )}
      {conditions.smoking && (
        <div className="flex items-center gap-4 rounded-xl bg-slate-100/50 px-6 py-4">
          <img src={yesSmokingIcon} alt="smoking" className="h-6 w-6" />
          Kouření povoleno
        </div>
      )}
      {!conditions.smoking && (
        <div className="flex items-center gap-4 rounded-xl bg-slate-100/50 px-6 py-4">
          <img src={noSmokingIcon} alt="smoking" className="h-6 w-6" />
          Kouření zakázáno
        </div>
      )}
      {conditions.parties && (
        <div className="flex items-center gap-4 rounded-xl bg-slate-100/50 px-6 py-4">
          <img src={yesPartiesIcon} alt="smoking" className="h-6 w-6" />
          Večírky a akce povoleny
        </div>
      )}
      {!conditions.parties && (
        <div className="flex items-center gap-4 rounded-xl bg-slate-100/50 px-6 py-4">
          <img src={noPartiesIcon} alt="smoking" className="h-6 w-6" />
          Večírky a akce zakázány
        </div>
      )}
      <div className="flex items-center gap-4 rounded-xl bg-slate-100/50 px-6 py-4">
        <img src={timeTwentyFourIcon} alt="smoking" className="h-5 w-5" />
        Rezervaci je možné zdarma zrušit do 24 hodin od objednání.
        <br />
        Poté se uplatňují 100% storno podmínky.
      </div>

      <div className="flex items-center gap-4 rounded-xl bg-slate-100/50 px-6 py-4">
        <img src={holdingHandKeyIcon} alt="smoking" className="h-5 w-5" />
        Pronajímá {business.name}
        <br />
        IČO {business.cin}
      </div>

      {surcharges.length > 0 && (
        <div className="flex gap-4 rounded-xl bg-slate-100/50 px-6 py-4">
          <img src={taxAltIcon} alt="smoking" className="mt-2 h-5 w-5" />
          <SurchargesCard surcharges={surcharges} surchargePayments={surchargePayments} />
        </div>
      )}

      <div className="flex items-center gap-4 rounded-xl bg-slate-100/50 px-6 py-4">
        <img src={termsDocumentIcon} alt="terms" className="h-5 w-5" />
        <a href="/docs/matevolno_vop_b2c.pdf" target="_blank" rel="noreferrer" className="underline">
          Obchodní podmínky
        </a>
      </div>
    </div>
  )
}

export default ConditionsCard
